export default "__VITE_ASSET__em3K$Qot__"